import { render, staticRenderFns } from "./recognition1.vue?vue&type=template&id=21600b5f&scoped=true"
import script from "./recognition1.vue?vue&type=script&lang=js"
export * from "./recognition1.vue?vue&type=script&lang=js"
import style0 from "./recognition1.vue?vue&type=style&index=0&id=21600b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21600b5f",
  null
  
)

export default component.exports